import type { NamePool } from "@/core/types.js";

export const sgNamePool: NamePool = {
  given: {
    male: ["Wei","Jun","Kai","Ethan","Aaron","Marcus","Ryan","Dylan","Sean","Joshua","Farhan","Hafiz","Rashid","Arjun","Vijay","Rajan","Kumar","Raj","Samuel","Daniel"],
    female: ["Hui","Ling","Xin","Sarah","Rachel","Priya","Siti","Nurul","Aisha","Jasmine","Michelle","Jessica","Chloe","Mei","Yanling","Kavitha","Nisha","Sunita","Grace","Faith"],
  },
  family: ["Tan","Lim","Lee","Ng","Wong","Chan","Koh","Teo","Chua","Goh","Ong","Sim","Foo","Yeo","Low","Bte","Bin","Rajah","Kumar","Singh"],
};
